import React from "react";
import PropTypes from "prop-types";
import { toPairs } from "lodash";
import numericalFieldHandler from "../../../utils/numericalFieldHandler";
import translateLabel from "../../../utils/translateLabel";

const RepeatWeekly = ({
	id,
	weekly: { interval, days, options },
	handleChange,
	translations,
}) => {
	let daysArray = toPairs(days);
	if (options.weekStartsOnSunday) {
		daysArray = daysArray.slice(-1).concat(daysArray.slice(0, -1));
	}

	return (
		<div>
			<div className="field is-grouped columns is-multiline is-mobile is-vcentered">
				<div className="control column is-narrow">
					{translateLabel(translations, "repeat.weekly.every")}
				</div>
				<div className="control column is-narrow">
					<input
						id={`${id}-interval`}
						name="repeat.weekly.interval"
						aria-label="Repeat weekly interval"
						className="input"
						value={interval}
						onChange={numericalFieldHandler(handleChange)}
					/>
				</div>
				<div className="control column is-narrow">
					{translateLabel(translations, "repeat.weekly.weeks")}
				</div>
			</div>

			<div className="field has-addons column is-narrow">
				{daysArray.map(([dayName, isDayActive]) => (
					<p className="control" key={dayName}>
						<button
							type="button"
							htmlFor={`${id}-${dayName}`}
							className={`button ${
								isDayActive ? "is-primary" : ""
							}`}
							name={`repeat.weekly.days[${dayName}]`}
							onClick={(event) => {
								const editedEvent = {
									...event,
									target: {
										...event.currentTarget,
										value: !isDayActive,
										name: event.currentTarget.name,
									},
								};

								handleChange(editedEvent);
							}}
						>
							<span>
								{translateLabel(
									translations,
									`days_short.${dayName.toLowerCase()}`
								)}
							</span>
						</button>
					</p>
				))}
			</div>
		</div>
	);
};

RepeatWeekly.propTypes = {
	id: PropTypes.string.isRequired,
	weekly: PropTypes.shape({
		interval: PropTypes.number.isRequired,
		days: PropTypes.shape({
			mon: PropTypes.bool.isRequired,
			tue: PropTypes.bool.isRequired,
			wed: PropTypes.bool.isRequired,
			thu: PropTypes.bool.isRequired,
			fri: PropTypes.bool.isRequired,
			sat: PropTypes.bool.isRequired,
			sun: PropTypes.bool.isRequired,
		}).isRequired,
		options: PropTypes.shape({
			weekStartsOnSunday: PropTypes.bool,
		}).isRequired,
	}).isRequired,
	handleChange: PropTypes.func.isRequired,
	translations: PropTypes.oneOfType([PropTypes.object, PropTypes.func])
		.isRequired,
};

export default RepeatWeekly;
